import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  ResourceType,
} from "../../../../services/cloudchipr.api";
import { currentAccountIdSelector } from "../../selectors/current-account/currentAccountIdSelector";
import { RootState } from "../../../store";
import { getFirstParentInHierarchyResourceType } from "../../../../utils/helpers/resources/getFirstParentInHierarchyResourceType";
import { addRegionsToFilters } from "../../../../utils/helpers/addRegionsToFilters";
import { currentAccountSelectedRegionsSelector } from "../../selectors/current-account/currentAccountSelectedRegionsSelector";

export const getResourceTypeDataWithoutFiltersFixedCacheKey = (
  type: ResourceType,
) => {
  return `postUsersMeV2OrganisationsCurrentByTypeResources-${type}-without-filters`;
};

export const getCurrentAccountResourceTypeWithoutFiltersDataThunk =
  createAsyncThunk(
    "getCurrentAccountResourceTypeDataWithoutFiltersThunk",
    async (resourceType: ResourceType, { dispatch, getState }) => {
      const state = getState() as RootState;
      const accountId = currentAccountIdSelector(state);
      const regions = currentAccountSelectedRegionsSelector(state);

      const type =
        getFirstParentInHierarchyResourceType(resourceType) ?? resourceType;

      if (!accountId) {
        return;
      }

      const appliedFilter = addRegionsToFilters(regions, {
        type: resourceType,
        filter_items: [],
        filter_groups: [],
        operators: [],
      });

      dispatch(
        cloudChiprApi.endpoints.postUsersMeV2OrganisationsCurrentByTypeResources.initiate(
          {
            type: type,
            body: {
              account_ids: [accountId],
              filter: appliedFilter,
            },
          },
          {
            fixedCacheKey: getResourceTypeDataWithoutFiltersFixedCacheKey(type),
          },
        ),
      ).unwrap();
    },
  );
